import { render } from "./BaseItemList.vue?vue&type=template&id=dafd76e2&scoped=true"
import script from "./BaseItemList.vue?vue&type=script&lang=ts"
export * from "./BaseItemList.vue?vue&type=script&lang=ts"

import "./BaseItemList.vue?vue&type=style&index=0&id=dafd76e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dafd76e2"

export default script